// @flow

import React, { Component } from "react";
import classNames from "classnames";

import type { TextWidget as TextWidgetProps } from "react-jsonschema-form/lib/components/widgets/TextWidget";
import PostWidgetChatBubble from "./post-widget-chat-bubble";
import PostWidgetInfoSection from "./post-widget-info-section";
import PostWidgetCharactersLength from "./post-widget-characters-length";
import "./text.scss";

const MAX_INPUT_LENGTH = 255;

type Props = $Exact<{
  ...TextWidgetProps,
  options: Object,
}>;

export type TextWidgetState = $Exact<{
  value: string,
  currentLength: number,
}>;

class TextWidget extends Component<Props, TextWidgetState> {
  state = {
    value: "",
    currentLength: 0,
  };

  constructor(props: Props) {
    super(props);
    this.state = {
      value: props.value,
      currentLength: props.options.withCharactersLimit
        ? (props.options.maxLength || MAX_INPUT_LENGTH) - (props.value ? props.value.length : 0)
        : 0,
    };
  }

  handleChange = (event: SyntheticEvent<HTMLInputElement>) => {
    const value = event.currentTarget.value;

    this.props.onChange(value);
    this.setState({
      value,
      currentLength: this.props.options.withCharactersLimit
        ? (this.props.options.maxLength || MAX_INPUT_LENGTH) - (value ? value.length : 0)
        : 0,
    });
  };

  render() {
    const props = {
      ...this.props,
      ...this.props.options,
      ...(this.props.schema && this.props.schema.hasOwnProperty("minimum")
        ? { min: this.props.schema.minimum }
        : {}),
      ...(this.props.schema && this.props.schema.hasOwnProperty("maxLength")
        ? { maxLength: this.props.schema.maxLength }
        : {}),
      onChange: this.handleChange,
      value: this.state.value || this.props.value || "",
    };

    if (this.props.options.withCharactersLimit && this.props.options.maxLength) {
      props.maxLength = `${this.props.options.maxLength}`;
    }

    delete props.readonly;
    delete props.formContext;
    delete props.autofocus;
    delete props.rawErrors;
    delete props.registry;
    delete props.schema;
    delete props.options;
    delete props.label;
    delete props.enumOptions;
    delete props.withCharactersLimit;
    delete props.labelposition;
    delete props.enumOptions;

    const shouldHighlightRequired =
      this.props.required &&
      !this.props.value &&
      (!this.props.rawErrors || !this.props.rawErrors.length);
    return (
      <div
        className={classNames("schema-form-text-input", {
          "form-input--required": shouldHighlightRequired,
        })}
      >
        <input
          type="text"
          {...props}
          className={classNames("form-control", this.props.className)}
        />
        <PostWidgetChatBubble options={this.props.options} />
        <PostWidgetInfoSection options={this.props.options} />
        <PostWidgetCharactersLength
          withCharactersLimit={this.props.options.withCharactersLimit}
          currentLength={this.state.currentLength}
        />
      </div>
    );
  }
}

export default TextWidget;
